import { render, staticRenderFns } from "./user-eval-type.vue?vue&type=template&id=23457c20&scoped=true"
import script from "./user-eval-type.vue?vue&type=script&lang=js"
export * from "./user-eval-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23457c20",
  null
  
)

export default component.exports